import React, { useState } from "react";
import background from "../../assets/images/screenBackground.jpg";
import {
  Modal,
  Form,
  Input,
  Button,
  Row,
  Col,
  notification,
  DatePicker,
} from "antd";
import { componentStyles } from "../setPassword/CredentialsStyles";
import { postNewUsername } from "../../api/password";
import ClipLoader from "react-spinners/ClipLoader";
import rules from "../../validations";
import { useNavigate } from "react-router-dom";
import { IS_PSUEDO_NAME_SYSTEM_GENERATED } from "../../redux/constants/Auth";
import moment from "moment";
import { isNull } from "lodash";

const screenBackground = {
  backgroundImage: `url(${background})`,
  backgroundSize: "cover",
  backgroundPosition: "center center",
  backgroundRepeat: "no-repeat",
  width: "100%",
  height: "100vh",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

const Password = () => {
  const [userData, setUserData] = useState();
  const [loader, setLoader] = useState(false);
  const [messageApi, contextHolder] = notification.useNotification();
  const navigate = useNavigate();

  const [form] = Form.useForm();

  const handleInputChange = (name, value) => {
    setUserData((prevUserData) => ({
      ...prevUserData,
      [name]: value,
    }));
  };

  const onFinish = () => {
    setUsernameRequest();
  };

  const setUsernameRequest = async () => {
    try {
      setLoader(true);
      const response = await postNewUsername(userData);
      setLoader(false);
      if (response.email) {
        localStorage.setItem("username", response.pseudoName);
        localStorage.setItem(IS_PSUEDO_NAME_SYSTEM_GENERATED, "false");
        localStorage.setItem("age", response.age);
        navigate("/landing-page");
      } else {
        messageApi.error({
          message: "Error",
          description: `Username couldn't be updated. Please contact your admin`,
        });
      }
    } catch (err) {
      console.log("err", err);
    }
  };

  const handleBirthdayChange = (date) => {
    if (isNull(date)) {
      form.setFieldsValue({ age: "" });
      handleInputChange("dob", "");
      handleInputChange("age", "");
    } else {
      const ageInYears = moment().diff(date, "years");
      const ageInMonths = moment().diff(date, "months") % 12;
      const age = `${ageInYears} Years & ${ageInMonths} Months`;
      form.setFieldsValue({ age });
      const formattedDate = moment(date).format("DD-MM-YYYY");
      handleInputChange("age", age);
      handleInputChange("dob", formattedDate);
    }
  };

  return (
    <>
      <div style={screenBackground}>
        <Modal
          visible={true}
          centered
          mask={false}
          closable={false}
          footer={null}
          title={null}
          width={544}
        >
          {contextHolder}
          <Form onFinish={onFinish} form={form}>
            <Row justify="center">
              <Col span={22} style={componentStyles.rowContainer}>
                User Details
              </Col>
              <Col span={22} style={componentStyles.usernameContainer}>
                <Form.Item
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                  name="password"
                  label={
                    <span style={componentStyles.formLabel}>Username</span>
                  }
                  rules={rules.username}
                  validateTrigger="onBlur"
                >
                  <Input
                    placeholder="Enter Username"
                    onChange={(val) =>
                      handleInputChange("pseudoName", val.target.value)
                    }
                  />
                </Form.Item>
              </Col>
              {/* <Col span={22} style={componentStyles.usernameContainer}>
                <Form.Item
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                  name="dob"
                  label={
                    <span style={componentStyles.formLabel}>
                      Would you like to share your Date of Birth?
                    </span>
                  }
                  rules={rules.requiredField}
                  validateTrigger="onBlur"
                >
                  <DatePicker
                    placeholder="Select Date of Birth"
                    format={"DD-MM-YYYY"}
                    onChange={handleBirthdayChange}
                    disabledDate={(current) => current > moment().endOf("day")}
                  />
                </Form.Item>
              </Col> */}

              {/* <Col span={22} style={componentStyles.usernameContainer}>
                <Form.Item
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                  name="age"
                  label={
                    <span style={componentStyles.formLabel}>Your Age</span>
                  }
                >
                  <Input placeholder="Age" disabled={true} />
                </Form.Item>
              </Col> */}
              <Col span={22}>
                <Row justify="center">
                  <Button
                    style={componentStyles.submitBtn}
                    type="primary"
                    htmlType="submit"
                  >
                    {loader ? (
                      <ClipLoader
                        color="#fff"
                        loading={loader}
                        size={15}
                        aria-label="Loading Spinner"
                        data-testid="loader"
                      />
                    ) : (
                      <span>Submit</span>
                    )}
                  </Button>
                </Row>
              </Col>
            </Row>
          </Form>
        </Modal>
      </div>
    </>
  );
};

export default Password;
